module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#album",
      toString: function () {
        return this.url;
      }
    }